// Template Generated by DataExtraction.py at 1716507313
        
import EscrowEng1 from "../../Forms/Escrow Forms/Escrow - Eng - 1.jpg";
import EscrowEng1Labels from "../../Labels/Escrow Forms/Escrow - Eng - 1.json";
import EscrowFr1 from "../../Forms/Escrow Forms/Escrow - Fr - 1.jpg";
import EscrowFr1Labels from "../../Labels/Escrow Forms/Escrow - Fr - 1.json";
import {
    defaultFontSize,
    drawTextOnLabel,
    fillCheckboxAtLabel,
    standardFormAlias,
    standardFormCompression,
    isLanguageEnglish,
    standardFormFormat,
    standardFormHeight,
    standardFormWidth,
    standardFormX,
    standardFormY,
    signatureLabel, 
    signatureTab
} from "../../PDFGenerationUtils";
import {POSSIBLE_SIGNERS} from "../../../Utils/PlanUtils";

import moment from "moment/moment";

/*
 * @param doc {jsPDF}
 */
const generate = (doc, data, quote, authStatus, i18n) => {

    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EscrowFr1Labels : EscrowEng1Labels;
    const formImage = isFrench ? EscrowFr1 : EscrowEng1;

    function fillCheckbox(value, label){
        fillCheckboxAtLabel(doc, value, label, labels);
    }
    
    function drawText(value, label){
        drawTextOnLabel(doc, value, label, labels);
    }

    // add image
    doc.addImage(formImage, standardFormFormat, labels["image"]["x"], labels["image"]["y"], labels["image"]["width"], labels["image"]["height"], null, standardFormCompression);

    /* define state variables here ie:
     * const subscriber = data.subscriber;
     * const jointSubscriber = data.jointSubscriber;
     * const beneficiary = data.beneficiary;
    */

    const subscriber = data.subscriber;

    const now = moment();
    // Drawing the form
    drawText(now.format("d"), "day");
    drawText(now.format("MMMM"), "month");
    drawText(subscriber.firstName + (subscriber.lastName ? " " + subscriber.lastName : ""), "s1Name");
    drawText(now.format("yyyy"), "year");
}

//Returns the signature definitions for the document
// This includes who needs to sign and where
const signatureDefinitions = (state, documentId, pageNumber, i18n) => {
    const isFrench = !isLanguageEnglish(i18n);
    const labels = isFrench ? EscrowFr1Labels : EscrowEng1Labels;
    const DRRecipientId = POSSIBLE_SIGNERS['Dealing Representative'];
    const subscriberRecipientId = POSSIBLE_SIGNERS['Subscriber'];
    const jointSubscriberRecipientId = POSSIBLE_SIGNERS['Joint Subscriber'];
    let signers = [];
    let signHereTabs = [];
    
    
    
    return signers;
}

export default {
    generate,
    signatureDefinitions
}
    